import React from 'react';
import Legends from '../Legends';
import PropTypes from 'prop-types';
import { select } from 'd3-selection';
import { scaleOrdinal } from 'd3-scale';

import './LegendNumeric.css';

export default class LegendNumeric extends Legends {
  static propTypes = {
    keys: PropTypes.array,
    size: PropTypes.array,
    colorScheme: PropTypes.array,
    className: PropTypes.string
  };

  componentDidMount() {
     this.renderChart()
  }

  componentDidUpdate() {
     this.renderChart()
  }

  renderChart = () => {
    const node = this.node;
    const padding = 30;
    const keys = this.props.keys;
    const zScale = scaleOrdinal(this.props.colorScheme).domain(keys);
    let offset = 0;
    select(node).selectAll('*').remove();

    const svg = select(node)

    const legend = svg.selectAll("g legends").data(keys);

    const legendBox = legend.enter()
      .append("g")
      .attr("transform", (d, i) => `translate(${((parseFloat(i) * 110) + padding)},20)`)

    legendBox.append("rect")
      .attr("width", 18)
      .attr("height", 18)
      .attr("fill", zScale);

    legendBox.append("text")
      .attr("dy", "1.2em")
      .attr("dx", "1.9em")
      .attr("font-size", "0.7em")
      .attr("text-anchor", "start")
      .attr("letter-spacing", "0.25")
      .text(d => d);

    svg.selectAll("g")
      .attr("transform", function (d, i) {
          const xPos = select(this).select("text").node().getComputedTextLength() + 30;
          offset = offset + xPos;
          return `translate(${(offset - xPos + 30)}, 20)`;
      })

  }

  render() {
    return (
      <svg
        className={`LegendNumeric ${this.props.className}`}
        ref={node => this.node = node}
        width={this.props.size[0]}
        height={this.props.size[1]}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Legends/LegendNumericComponent/LegendNumeric.js